import React, {useState} from "react"

import textFieldStyles from "./TextField.module.css"

// The props for this component are "type", "value", "setValue", "label"

const TextField = ({type, value, setValue, label, placeHolder, showInputError }) => {
  const [inputType, setInput] = useState(type)

  const validateInput = () => {
  }

  const handleError = () => {
    if (showInputError && value.length === 0) {
      return true;
    }
    return false
  }

  const renderShowPassword = () => {
    if (type === "password") {
      return inputType === "password" ? <p className={textFieldStyles.showPassword} onClick={() => setInput("text")}>Show</p> :
      <p className={textFieldStyles.showPassword} onClick={() => setInput("password")}>Hide</p>
    }
  }

  return (
    <div className={textFieldStyles.container}>
      <label className={textFieldStyles.label}>{label}</label>
      <input
        type={inputType}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onBlur={(e) => validateInput()}
        className={handleError() ? textFieldStyles.errorInput : textFieldStyles.input}
        // placeholder={placeHolder ? placeHolder : ""}
      />

      {
        handleError() && <p className={textFieldStyles.errorText}>Please Enter {label} Field!</p>
      }

      {
        renderShowPassword()
      }
    </div>
  )
}

export default TextField